export const sanitizeFilename = (name: string): string =>
  name.replace(/[/\\:*?"<>|]/g, '_').trim() || 'document';
